import parsePhoneNumberFromString from 'libphonenumber-js';
import { z } from 'zod';

export const stringSchema = z.string();

export const noEmptyStringSchema = z.string().min(1, 'Role type is required.');

export const urlSchema = z.string().url({ message: 'Invalid URL' });

export const numSchema = z.number().gt(0, 'Must be greater than 0.');

export const emailSchema = z
  .string({ message: 'please provide a valid email' })
  .email({ message: 'please provide a valid email' });

export const dateOfBirthSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
  message: 'Date of birth must be in YYYY-MM-DD format',
});

export const phoneSchema = z
  .string({ message: 'Please enter a valid phone number' })
  .trim()
  .refine(
    (val) => {
      const phone = parsePhoneNumberFromString(val);
      return phone?.isValid();
    },
    { message: 'Please enter a valid phone number' }
  );
